<template>
  <div class="insights-unusual-activity-fake-table">
    <AppTable
      :loading="false"
      :selectable="false"
      :table-data="rows"
      :rows-count="rows.length"
    >
      <AppTableColumn
        v-slot="{ row }"
        header="Member"
        name="name"
        cell-classes="max-width fake-cell fake-cell-member"
      >
        <img
          class="fake-blur-image blur-user"
          :src="row.userBlurSrc"
          alt=""
        />
      </AppTableColumn>
      <AppTableColumn
        header="Total time"
        name="total_duration"
        cell-classes="fake-cell"
      >
        <img
          class="fake-blur-image blur-time"
          :src="timeBlurSrc"
          alt=""
        />
      </AppTableColumn>
      <AppTableColumn
        header="Previous 60 days"
        name="previous_60_days"
        cell-classes="fake-cell"
      >
        <img
          class="fake-blur-image blur-time"
          :src="timeBlurSrc"
          alt=""
        />
      </AppTableColumn>
      <AppTableColumn
        header="Activity classification"
        :header-tooltip="INSIGHTS.tooltips.confidenceLevel.content"
        header-tooltip-type="info-filled"
        header-classes="no-wrap"
        name="confidence_level"
        cell-classes="fake-cell"
      >
        <InsightsUnusualActivityConfidenceBadge :confidence-level="HIGH_CONFIDENCE_LEVEL" />
      </AppTableColumn>
    </AppTable>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';
import AppTable from '~/components/AppTable.vue';
import AppTableColumn from '~/components/AppTableColumn.vue';
import InsightsUnusualActivityConfidenceBadge from '~/components/insights/InsightsUnusualActivityConfidenceBadge.vue';
import {
  NO_INSIGHTS_UA_BLUR_USER_1,
  NO_INSIGHTS_UA_BLUR_USER_2,
  NO_INSIGHTS_UA_BLUR_USER_3,
  NO_INSIGHTS_UA_BLUR_USER_4,
  NO_INSIGHTS_UA_BLUR_USER_5,
  NO_INSIGHTS_UA_TIME_BLUR,
} from '~/rails_assets';

const HIGH_CONFIDENCE_LEVEL = 2;

const FAKE_ROWS = [
  { id: 1, userBlurSrc: NO_INSIGHTS_UA_BLUR_USER_1 },
  { id: 2, userBlurSrc: NO_INSIGHTS_UA_BLUR_USER_2 },
  { id: 3, userBlurSrc: NO_INSIGHTS_UA_BLUR_USER_3 },
  { id: 4, userBlurSrc: NO_INSIGHTS_UA_BLUR_USER_4 },
  { id: 5, userBlurSrc: NO_INSIGHTS_UA_BLUR_USER_5 },
];

export default {
  name: 'InsightsUnusualActivityFakeTable',
  components: {
    AppTable,
    AppTableColumn,
    InsightsUnusualActivityConfidenceBadge,
  },
  data: () => ({
    INSIGHTS,
    HIGH_CONFIDENCE_LEVEL,
    rows: FAKE_ROWS,
    timeBlurSrc: NO_INSIGHTS_UA_TIME_BLUR,
  }),
};
</script>
